import React, { useEffect, useState, useRef } from "react";
import ButtonElement from '../UiComponents/ButtonElement';
import AutoCompleteElement from "../UiComponents/AutoCompleteElement";
import { api } from "../../Apis/interceptor";
import { get } from "../../Services/customerServices";
import ToastElement from "../UiComponents/ToastElement";
import _ from "lodash";
import { useNavigate, useLocation } from 'react-router-dom';
import DropdownElement from "../UiComponents/DropdownElement";
import { getField } from "../../Services/tooltipService";
import { Dialog } from "primereact/dialog";
import PortfolioList from "../../Pages/Base/Portfolio/portfolioList";
import StakeHolderList from "../../Pages/Base/Stakeholders/StakeHolderList";
import Programmes from "../../Pages/Base/Programmes/Programmes";
import { getNotifications, updateStatus, clearNotifications, getPendingCount } from "../../Services/notificationService";
import moment from "moment";
import socket from "../../socket";
import { InputIcon } from "primereact/inputicon";
import InputTextElementElement from "../UiComponents/InputTextElement";
import TextareaElement from "../UiComponents/TextareaElement";
import { useOpportunity } from "../../Providers/OpportunityContext";
import { useStakeholder } from "../../Providers/StakeholderContext";
import { useProgramme } from "../../Providers/ProgrammeContext";

const Header = (props) => {
	// Header component content, utilizing the headerLabel prop
	const [menuOpen, setMenuOpen] = useState(false);
	const [searchData, setSearchData] = useState([]);
	const [matchedRecords, setMatchedRecords] = useState([]);
	const [searchedData, setSearchedData] = useState('');
	const [customerShort, setCustomerShort] = useState('');
	const [customerDetails, setCustomerDetails] = useState({});
	const [headerLabel, setHeaderLabel] = useState('');
	const [modalAddModules, setModalAddModules] = useState(false);
	const [modules, setModules] = useState([]);
	const [selectedModule, setSelectedModule] = useState('');
	const [showOpportunity, setShowOpportunity] = useState(false);
	const [showFramework, setShowFramework] = useState(false);
	const [showClient, setShowClient] = useState(false);
	const [isCollapsed, setIsCollapsed] = useState(false);
	const [notifications, setNotifications] = useState([]);
	const [pendingCount, setPendingCount] = useState(0);
	const [helpEmail, setHelpEmail] = useState(false);
	const [subject, setSubject] = useState('');
	const [message, setMessage] = useState('');
	const { globalOpportunityData } = useOpportunity();
	const { globalStakeholderData } = useStakeholder();
	const { globalProgrammeData } = useProgramme();

	const toastRef = useRef();
	const navigate = useNavigate();
	let location = useLocation();

	var enduser = localStorage.getItem("enduser")
	if (enduser) {
		var tmpData = JSON.parse(enduser);
		if(tmpData === null){
			navigate("/login")
			localStorage.clear()
		}
	}
	
	var userPrivileges = localStorage.getItem("user_privileges")
	if (userPrivileges) {
		var tmpPrivilege = JSON.parse(userPrivileges);
		var privileges = {};
		if(tmpPrivilege !== undefined && tmpPrivilege !== null){
			privileges.Opportunity = tmpPrivilege[0]?.opp_edit;
			privileges.Client = tmpPrivilege[0]?.client_readwrite;
			privileges.Framework = tmpPrivilege[0]?.framework_readwrite;
			privileges.Organisation = tmpPrivilege[0]?.organisation_readwrite;
		}
	}
	
	useEffect(() => {
		getCustomerDetails()
		initialgetFields()
		getPendingCountData()
	}, [])

	useEffect(() => {
		if (props.headerLabel) {
			setHeaderLabel(props.headerLabel)
		}
	}, [props.headerLabel])

	useEffect(() => {
		if (isCollapsed) {
			getNotificationData()
		}
	}, [isCollapsed])

	useEffect(() => {
		socket.on('getNotifications', async () => {
			getPendingCountData()
		});
	}, []);

	const getPendingCountData = async () => {
		var countData = await getPendingCount(tmpData.customer, tmpData.userid)
		if (countData && countData.data) {
			var pendingCount = countData.data.pendingCount;
			setPendingCount(pendingCount)
			if (isCollapsed) {
				getNotificationData()
			}
		}
	}

	const initialgetFields = async () => {
		var fieldData = await getField(tmpData.customer)
		if ( fieldData && fieldData?.data) {
			var clientModuleData = fieldData.data;
			var modules = [
				{ label: _.find(clientModuleData.cust[0]?.modules, { module_name: "Pipeline" }).display_name, value: 'Opportunity', template: "projectModal.html" },
				{ label: _.find(clientModuleData.cust[0]?.modules, { module_name: "Clients" }).display_name, value: 'Client', template: "clientModal.html" },
				{ label: _.find(clientModuleData.cust[0]?.modules, { module_name: "Frameworks" }).display_name, value: 'Framework', template: "frameworkModal.html" },
			]
			setModules(modules)
		}
	}

	const getCustomerDetails = async () => {
		var customerData = await get(tmpData.customer)
		if(customerData && customerData.data){
			setCustomerDetails(customerData.data)
			setCustomerShort(customerData.data.customer_short)
		}
	}

	const menuOpenClick = () => {
		setMenuOpen(true);
		props.onSelectHamburger(menuOpen);
	}

	const getRecords = async (val) => {
		const searchText = val.query.trim();
		setSearchedData(searchText)
		if (searchText) {
			var params = {
				cust_id: tmpData.customer,
				searchVal: searchText
			}
			if (tmpData.branch.branch_key != 'main') {
				params.branch_id = tmpData.branch.branch_id;
			}
			const response = await api.get(`/api/v1/getMatchedRecords`, { params: params });
			if (response && response.data && response.data.matchedRecords.length > 0) {
				const matchedNames = response.data.matchedRecords.map(
					(match) => match.record_name
				);
				setMatchedRecords(response.data.matchedRecords)
				setSearchData(matchedNames)
			} else {
				setSearchData([])
			}
		}
	}

	const getVersion = (versions) => {
		var currVersion = "v1";
		var found = versions.filter(version => version.checked === true);
		if (found.length) {
			currVersion = found[0].folder;
		}
		return currVersion;
	}

	const checkVersion = (module) => {
		var versions = [];
		var versionAvailble = false;
		for (var i = 0; i < customerDetails.version_maintained.length; i++) {
			if (customerDetails.version_maintained[i].module_name == module) {
				versionAvailble = true;
				versions = customerDetails.version_maintained[i].version_detail;
			}
		}
		return {
			versionAvailble: versionAvailble,
			versions: versions
		}
	}

	const onSelect = (item) => {
		setSearchedData(item.value)
		const matchedObject = matchedRecords.find(
			(match) => match.record_name === item.value
		);

		if (!_.isEmpty(matchedObject)) {
			var params = {};
			if (privileges[matchedObject.module]) {
				params[matchedObject.identifier_label] = matchedObject._id;
				var versionDetails = checkVersion(matchedObject.module);
				params.customer_short = customerShort;
				if (versionDetails.versionAvailble) {
					params.version = getVersion(versionDetails.versions)
				} else {
					params.version = 'v1'
				}
				if (matchedObject.module === "Opportunity") {
					navigate(`/portfolio/${params.opportunity_id}/${params.customer_short}/${params.version}`, {
						state: {
							opportunityName: item.value, opportunity_id: params.opportunity_id
						}
					});
					setHeaderLabel('Portfolio')
				} else if (matchedObject.module === "Client") {
					navigate(`/stakeholder/${params.client_id}/${params.customer_short}/${params.version}`, {
						state: {
							clientName: item.value
						}
					});
					setHeaderLabel('Stakeholders')
				} else if (matchedObject.module === "Framework") {
					navigate(`/programme/${params.framework_id}/${params.customer_short}`, {
						state: {
							frameworkName: item.value,
							framework_id: params.framework_id,
						}
					})
					setHeaderLabel('Programmes')
				}
				setSearchedData('')
			} else {
				toastRef.current.showToast({
					type: 'error',
					message: "Permission Denied"
				});
			}
		}
	}

	const addModules = () => {
		setModalAddModules(true)
	}

	const closeAddModule = () => {
		setModalAddModules(false)
		setShowOpportunity(false)
		setShowClient(false)
		setShowFramework(false)
		setSelectedModule('')
	}

	const submit = () => {
		var data = {};
		if (selectedModule && selectedModule != "") {
			data.isModuleSelected = true;
			data.selectedModule = selectedModule;
			if (privileges[selectedModule]) {
				if (selectedModule === 'Opportunity') {
					if (location.pathname.startsWith('portfolio')) {
						setShowOpportunity(true)
					} else {
						navigate('/portfolio')
						setShowOpportunity(true)
					}
				} else if (selectedModule === 'Client') {
					if (location.pathname.startsWith('stakeholders')) {
						setShowClient(true)
					} else {
						navigate('/stakeholders')
						setShowClient(true)
					}
				} else if (selectedModule === 'Framework') {
					if (location.pathname.startsWith('programmes')) {
						setShowFramework(true)
					} else {
						navigate('/programmes')
						setShowFramework(true)
					}
				}
			}
			else {
				toastRef.current.showToast({
					type: 'error',
					message: "Permission Denied"
				});
			}
		}
		else {
			toastRef.current.showToast({
				type: 'error',
				message: "Please select the module"
			});
		}
	}

	const renderFooter = () => {
		return (
			<div className="cancel-footer">
				<div className="align-center justify-end pb-0">
					<ButtonElement label="Cancel" className="cancel-new-button" onClick={() => closeAddModule()} />
					<ButtonElement type="submit" label="Ok" className="save-button" onClick={() => submit()} />
				</div>
			</div>
		);
	};

	const showData = () => {
		setIsCollapsed(true)
	}

	const getNotificationData = async () => {
		var notificationDetails = await getNotifications(tmpData.customer, tmpData.userid)
		if (notificationDetails && notificationDetails.data) {
			setPendingCount(0)
			var notifications = notificationDetails.data.notifications;
			setNotifications(notifications)
			var update = await updateStatus(tmpData.customer, tmpData.userid)
			if (update && update.data && update.data.status) {
			}
		}
	}

	const closeNotification = () => {
		setIsCollapsed(false)
	}

	const clearNotificationsDetails = async () => {
		var clearData = await clearNotifications(tmpData.customer, tmpData.userid)
		if (clearData && clearData.data && clearData.data.status) {
			getNotificationData();
		}
	}

	const dateFormatter = (date) => {
		return moment(date, "DD-MM-YYYY").calendar(null, {
			sameDay: "[Today]",
			lastDay: "[Yesterday]",
			lastWeek: "[Last] dddd",
			sameElse: "DD MMM, YYYY",
		});
	};

	const renderFooterNotification = () => {
		return (
			<div className="cancel-footer">
				<div className="align-center justify-end pb-0">
					{
						notifications.length > 0 &&
						<ButtonElement type="submit" label="Delete" className="save-button" onClick={() => clearNotificationsDetails()} />
					}
				</div>
			</div>
		);
	}

	const redirectNotification = (notification) => {
		var versionDetails = checkVersion(notification.module);
		var version = ''
		if (versionDetails.versionAvailble) {
			version = getVersion(versionDetails.versions)
		} else {
			version = 'v1'
		}
		if (notification.module == 'Client') {
			navigate(`/stakeholder/${notification.id}/${customerShort}/${version}`, {
				state: {
					clientName: notification.tab_name
				}
			});
			setHeaderLabel('Stakeholders')
			setIsCollapsed(false)
		}
		else {
			navigate(`/portfolio/${notification.id}/${customerShort}/${version}`, {
				state: {
					opportunityName: notification.tab_name, opportunity_id: notification.id
				}
			});
			setHeaderLabel('Portfolio')
			setIsCollapsed(false)
		}
	}

	const showEmailPrompt = () => {
		setHelpEmail(true)
	}

	const sendMail = async () => {
		if (subject != '' && message != '') {
			var currentUrl = location.pathname.split("/");
			var page = '';
			if (currentUrl[1] == 'clients') {
				page = 'Clients';
			} else if (currentUrl[1] == 'opportunity') {
				page = 'Pipeline';
			} else if (currentUrl[1] == 'myAccount') {
				page = 'My Account';
			} else if (currentUrl[1] == 'controlPanel') {
				page = "Control Panel - " + currentUrl[5];
			} else {
				page = currentUrl[1].charAt(0).toUpperCase() + currentUrl[1].slice(1);
			}

			const response = await api.get(`/api/v1/helpEmail`, {
				params: {
					subject: subject,
					message: message,
					senderName: tmpData.firstname + " " + tmpData.surname,
					senderRole: tmpData.role,
					senderEmail: tmpData.email,
					customer: tmpData.customer,
					page: page
				}
			});
			if (response && response.data) {
				setSubject('')
				setMessage('')
				setHelpEmail(false)
				toastRef.current.showToast({
					type: 'success',
					message: "Mail has been sent"
				});
			}
		} else {
			toastRef.current.showToast({
				type: 'error',
				message: "Please fill all fields"
			});
		}
	}

	const renderFooterEmail = () => {
		return (
			<div className="cancel-footer">
				<div className="align-center justify-end pb-0">
					<ButtonElement type="submit" label="Send" className="save-button" onClick={() => sendMail()} />
				</div>
			</div>
		);
	}

	const closeEmail = () => {
		setHelpEmail(false)
		setSubject('')
		setMessage('')
	}

	return (
		<div className='w-100 header-class padding-8'>
			<ToastElement ref={toastRef} />
			<div className='justify-between align-center'>
				<div className={`menu-icon ${props.isOpen ? 'hideMenuIcon' : 'show'}`}>
					<i className="pi pi-bars navIcon" onClick={() => menuOpenClick()}></i>
				</div>
				<div className="flex justify-content-between flex-wrap">
					<div className="flex align-items-center justify-content-center font-bold m-2">
						{
							!_.isEmpty(globalOpportunityData) && globalOpportunityData != undefined && location.pathname.startsWith("/portfolio") ?
								<p className="header-label m-0">{headerLabel + ' - ' + globalOpportunityData.opportunity_name}</p> :
								!_.isEmpty(globalStakeholderData) && globalStakeholderData != undefined && location.pathname.startsWith("/stakeholder") ?
									<p className="header-label m-0">{headerLabel + ' - ' + globalStakeholderData.client_name}</p> :
									!_.isEmpty(globalProgrammeData) && globalProgrammeData != undefined && location.pathname.startsWith("/programme") ?
										<p className="header-label m-0">{headerLabel + ' - ' + globalProgrammeData.framework_name}</p> :
										<p className="header-label m-0">{headerLabel}</p>
						}
					</div>
					<div className="flex align-items-center justify-content-center font-bold m-2 w-30">
						{
							<InputIcon
								className="pi pi-envelope pointer mr-20"
								onClick={showEmailPrompt}
							/>
						}
						{
							pendingCount > 0 ?
								<ButtonElement type="button" icon="pi pi-bell" rounded text badge={pendingCount.toString()} badgeClassName="p-badge-danger" className="pointer notification-icon" onClick={showData} /> :
								<ButtonElement type="button" icon="pi pi-bell" rounded text className="pointer notification-icon" onClick={showData} />
						}
						<span className="p-input-icon-left p-input-icon-right search-wrapper ml-20">
							<i className="pi pi-search pt-18" />
							<AutoCompleteElement
								value={searchedData}
								onChangeValue={(e) => onSelect(e)}
								placeholder="Search"
								suggestions={searchData}
								completeMethod={getRecords}
								className="w-full"
								isPurposeScore={true}
							/>
						</span>
						<ButtonElement icon='pi pi-plus' className='ml-20 top-add-button width-15' onClick={addModules} />
					</div>
				</div>
			</div>
			{
				showOpportunity &&
				<PortfolioList
					showCreateNew={true}
					hideDataTable={true}
					hidePopUp={closeAddModule}
				/>
			}
			{
				showClient &&
				<StakeHolderList
					visible={true}
					hideDataTable={true}
					hidePopUp={closeAddModule}
				/>
			}
			{
				showFramework &&
				<Programmes
					createVisible={true}
					hideDataTable={true}
					hidePopUp={closeAddModule}
				/>
			}
			<Dialog
				visible={modalAddModules}
				breakpoints={{ "960px": "75vw", "641px": "90vw" }}
				header="What do you want to create?"
				modal
				footer={renderFooter}
				onHide={closeAddModule}
				className="table-dialog width-32"
				draggable={false}
			>
				<div className="confirmation-content">
					<div className="form-group row align-items-center mb-0 mt-0">
						<div className="col-md-4 pl-0">
							<label className="form-label text-left">
								Select Module:
							</label>
						</div>
						<div className="col pr-0">
							<DropdownElement
								value={selectedModule}
								onChange={(e) => setSelectedModule(e.value)}
								options={(modules != undefined && modules.length > 0) ? modules : []}
								optionLabel="label"
								placeholder="-- Please select --"
								className="w-full"
							/>
						</div>
					</div>
				</div>
			</Dialog>
			<Dialog
				visible={isCollapsed}
				breakpoints={{ "960px": "75vw", "641px": "90vw" }}
				header="Notifications"
				modal
				footer={renderFooterNotification}
				onHide={closeNotification}
				className="table-dialog width-32"
				position="right"
				draggable={false}
			>
				<div className="confirmation-content">
					<div className="form-group row align-items-center mb-0 mt-0">
						<div className="col pl-0 pr-0">
							{
								notifications.length === 0 &&
								<label className="form-label text-center font-600">No new notifications</label>
							}
							{
								notifications.length > 0 && notifications.map((notification, index) => {
									return (
										<div key={index} className="border-service">
											<div>
												<label className="form-label text-left">{'New responsibility'}&nbsp;</label>
												<label className="form-label text-left font-600">{notification.action}&nbsp;</label>
												<label className="form-label text-left">{'added in'}&nbsp;</label>
												<label className="form-label text-left font-600">{notification.name + ' - '}</label>
												{
													notification.sub_module_display_name != undefined &&
													<label className="form-label-text text-left pointer mar-l-5" onClick={() => redirectNotification(notification)}>{notification.sub_module_display_name}</label>
												}
												{
													notification.sub_module_display_name == undefined &&
													<label className="form-label-text text-left pointer mar-l-5" onClick={() => redirectNotification(notification)}>{notification.sub_module}</label>
												}
												<label className="form-label text-left">&nbsp;{'tab'}</label>
											</div>
											<div className="text-right">
												<label className="form-label text-left">{dateFormatter(notification.sent_date_string) != 'Today' ? dateFormatter(notification.sent_date_string) + "at" : ""}&nbsp;</label>
												<label className="form-label text-left">{notification.sent_time_string}</label>
											</div>
										</div>
									);
								})
							}
						</div>
					</div>
				</div>
			</Dialog>
			<Dialog
				visible={helpEmail}
				breakpoints={{ "960px": "75vw", "641px": "90vw" }}
				header="Send Mail"
				modal
				footer={renderFooterEmail}
				onHide={closeEmail}
				className="table-dialog width-32"
				position="center"
				draggable={false}
			>
				<div>
					<div className="form-group row align-items-center mb-0 mt-0">
						<div className="col pl-0 pr-0 d-flex">
							<label className="form-label text-center">Help message will be sent to <a className="form-label-text text-left mar-l-5">product@myconsole.co.uk</a></label>
						</div>
					</div>
					<div className="form-group row align-items-center mb-0 mt-0">
						<div className="col pl-0 pr-0">
							<InputTextElementElement
								name="subject"
								className="dropdown-field-handle"
								value={subject}
								placeholder="Subject"
								onChange={(e) => setSubject(e.target.value)}
							/>
						</div>
					</div>
					<div className="form-group row align-items-center mb-0 mt-0">
						<div className="col pl-0 pr-0">
							<TextareaElement
								placeholder="Message"
								name="message"
								className="w-full"
								value={message}
								onChange={(e) => setMessage(e.target.value)}
								rows={3}
							/>
						</div>
					</div>
				</div>
			</Dialog>
		</div>
	);
};

export default Header;
